import { memo, useEffect } from 'react';
import {
  Box,
  Breakpoint,
  PressableIcon,
  useBreakpoint,
} from '@bonanza-social/moonlight';
import { ModalExtendedProps } from '@bonanza-social/navigation';
import useOnfido from '../../hooks/useOnfido';

function OnfidoModal({ close }: ModalExtendedProps) {
  const breakpoint = useBreakpoint();
  const onfido = useOnfido();
  const isMobile = breakpoint === Breakpoint.MOBILE;

  useEffect(() => {
    const instancePromise = onfido.init({
      onComplete: close,
    });

    return () => {
      instancePromise.then((instance) => {
        instance?.tearDown();
      });
    };
  }, [onfido, close]);

  return (
    <Box
      id="onfido-container"
      width={isMobile ? '100%' : 512}
      height={isMobile ? '100%' : 600}
      maxHeight="100%"
      variant={isMobile ? 'default' : 'outline-gradient'}
      borderRadius="radius-400"
    >
      <PressableIcon
        name="close"
        gradient="accentBackground"
        position="absolute"
        top="space-300"
        right="space-300"
        width="space-600"
        height="space-600"
        onPress={close}
        zIndex={10}
      />
    </Box>
  );
}

export default memo(OnfidoModal);
